<template>
  <div class="e2e-gfx-feedback">
    <!-- forms hidden field to keep track which board was submitted -->
    <input type="hidden" :name="fragment.uuid" :value="fragment.uuid">

    <div v-for="(coordinate, name) in feedback.coordinates" class="row" :key="name">
      <label class="col-sm-4 col-form-label-sm">Punkt:
        <b>{{name}}</b>
      </label>

      <div class="col-sm-4">
        <div class="input-group input-group-sm">
          <div class="input-group-prepend">
            <span class="input-group-text">X</span>
          </div> 
              <input  class="form-control" 
                      :class="coordinate.xValid ? '' : 'is-invalid mc-invalid-input'"
                      :readonly="!coordinate.userEditable" 
                      :name="coordinate.xName"
                      :value="coordinate.x" 
                      @input="onXChange(coordinate,$event)"/> 
        
        </div>
      </div>

      <div class="col-sm-4">
        <div class="input-group input-group-sm">
          <div class="input-group-prepend">
            <span class="input-group-text">Y</span>
          </div>

              <input  class="form-control" 
                      :class="coordinate.yValid ? '' : 'is-invalid mc-invalid-input'"
                      :readonly="!coordinate.userEditable"  
                      :name="coordinate.yName"
                      :value="coordinate.y" 
                      @input="onYChange(coordinate,$event)"/>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { applyFeedbackNewFeedback, BUS } from "./gfx.js";
import { validateReal } from "../../utils.js";

export default {
  name: "fragment-gfx-form",
  props: ["fragment"],
  data() {
    return {
      feedback: {
        coordinates: {}
      }
    };
  },
  methods: {
    onXChange(coordinate, event){
      let rawValue = event.target.value;
      coordinate.x = rawValue; // eval(rawValue);  
      coordinate.xValid =  validateReal(rawValue,{}) === null;
      this.onUpdateBoard();
    },
    onYChange(coordinate, event){
      let rawValue = event.target.value;
      coordinate.y = rawValue; // eval(rawValue);
      coordinate.yValid =  validateReal(rawValue,{}) === null;
      this.onUpdateBoard();
    },
    onUpdateBoard() {
      const uuid = this.fragment.uuid;
      const feedback = JSON.parse(JSON.stringify(this.feedback));
      applyFeedbackNewFeedback(uuid, feedback);
    }
  }, 
  mounted() {
    const that = this;
    const uuid = that.fragment.uuid;
    BUS.$on("feedback-changed", function({ targetUuid, feedback }) {
      if (uuid === targetUuid) {
        that.feedback = JSON.parse(JSON.stringify(feedback));
      }
    });
  }
};
</script>
 

<style scoped>
</style>